module.exports = __webpack_public_path__ + "img/rama-channel.6341e199.png";